import React from 'react';

// Bootstrap-3-compatible pagination: <Pagination><Pagination.Prev/>
// <Pagination.Item active/><Pagination.Next/></Pagination>.
const Pagination = ({ className, style, children, ...rest }) => (
  <ul className={['ui-pagination', className].filter(Boolean).join(' ')} style={style} {...rest}>
    {children}
  </ul>
);

/**
 * @param {object} props
 * @param {boolean} [props.active] Highlighted current page.
 * @param {boolean} [props.disabled] Unclickable; onClick is dropped.
 * @param {() => void} [props.onClick]
 */
const Item = ({ active, disabled, onClick, className, children, ...rest }) => (
  <li
    className={['ui-pagination__item', active && 'active', disabled && 'disabled', className]
      .filter(Boolean)
      .join(' ')}
  >
    <button type="button" onClick={disabled ? undefined : onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  </li>
);

const Prev = (props) => (
  <Item {...props} aria-label="Previous">
    <span aria-hidden="true">&lsaquo;</span>
  </Item>
);

const Next = (props) => (
  <Item {...props} aria-label="Next">
    <span aria-hidden="true">&rsaquo;</span>
  </Item>
);

Pagination.Item = Item;
Pagination.Prev = Prev;
Pagination.Next = Next;

export default Pagination;
